/*eslint-disable*/
import React from "react";
import {
    ApplyRatingBlock,
    RatingBlock,
    RatingFullBlock,
    ReviewContainer,
    ReviewValue,
    ReviewValueContent,
} from "../../Review/widgets/Styled";
import {numberWithCommas} from "../../../../utils/string";
import PropTypes from "prop-types";
import ReviewSummary from "../../Review/widgets/ReviewSummary";

const CounselingRatingWidget = (props) => {
    const {counsellingRatingData} = props.data;
    const {makeVerticalRatingStyle = false, showStarOverallRating = false} = props;
    const reviewImageWidth = 82.8,
        starTotalWidth = 70.64;
    const singleStartArea = (starTotalWidth / (reviewImageWidth * 5)) * 100,
        singleSpaceArea = ((reviewImageWidth - starTotalWidth) / (reviewImageWidth * 4)) * 100;
    const rating = counsellingRatingData.overallRating;
    const noOfSpaces = Math.ceil(rating) > 1 ? Math.ceil(rating) - 1 : 0;
    return (
        <ReviewContainer makeVerticalRatingStyle={makeVerticalRatingStyle}>
            <ReviewValueContent makeVerticalRatingStyle={makeVerticalRatingStyle}>
                <strong>Overall Rating</strong>
                <ReviewValue>{counsellingRatingData.overallRating}</ReviewValue>
                {showStarOverallRating && (
                    <ApplyRatingBlock>
                        <RatingBlock ReviewRatingBlock>
                            <RatingFullBlock
                                width={rating * singleStartArea + noOfSpaces * singleSpaceArea}
                                ReviewRatingFullBlock
                            />
                        </RatingBlock>
                    </ApplyRatingBlock>
                )}

                <span>{numberWithCommas(counsellingRatingData.ratingCount)} Reviews</span>
            </ReviewValueContent>
            <ReviewSummary data={props.data} makeVerticalRatingStyle={makeVerticalRatingStyle} />
        </ReviewContainer>
    );
};

CounselingRatingWidget.propTypes = {
    widgetData: PropTypes.object,
    makeVerticalRatingStyle: PropTypes.bool,
};
export default CounselingRatingWidget;
